export const tourop = {
  tourops: [
    {
      kod: "ALMA",
      nazwa: "Almatur",
      naszid: "TOOP00175"
    },
    {
      kod: "OREX",
      nazwa: "Anex Poland",
      naszid: "TOOP00181"
    },
    {
      kod: "ATLA",
      nazwa: "Atlas Tours",
      naszid: "TOOP00147"
    },
    {
      kod: "ATLR",
      nazwa: "Atlas Tours Rejsy",
      naszid: "TOOP00147"
    },
    {
      kod: "BVBE",
      nazwa: "Best Reisen",
      naszid: "TOOP00132"
    },
    {
      kod: "BVBX",
      nazwa: "Best Reisen Egzotyka",
      naszid: "TOOP00132"
    },
    {
      kod: "WEZY",
      nazwa: "Coral Travel",
      naszid: "TOOP00034"
    },
    {
      kod: "WEZX",
      nazwa: "Coral Travel-Egzotyka",
      naszid: "TOOP00182"
    },
    {
      kod: "ECCX",
      nazwa: "Ecco Holiday",
      naszid: "TOOP00183"
    },
    {
      kod: "ECTR",
      nazwa: "Ecco Travel",
      naszid: "TOOP00043"
    },
    {
      kod: "ETI",
      nazwa: "ETI",
      naszid: "TOOP00179"
    },
    {
      kod: "VXEM",
      nazwa: "Europe Mountains",
      naszid: "TOOP00178"
    },
    {
      kod: "EXIM",
      nazwa: "Exim Tours",
      naszid: "TOOP00039"
    },
    {
      kod: "FNCB",
      nazwa: "Fun Club",
      naszid: "TOOP00127"
    },
    {
      kod: "GRCS",
      nazwa: "Grecos",
      naszid: "TOOP00130"
    },
    {
      kod: "SYIN",
      nazwa: "Index Polska",
      naszid: "TOOP00184"
    },
    {
      kod: "JOIN",
      nazwa: "Join!Up",
      naszid: "TOOP00185"
    },
    {
      kod: "KARP",
      nazwa: "Karpatia",
      naszid: "TOOP00186"
    },
    {
      kod: "SYKM",
      nazwa: "Kompas",
      naszid: "TOOP00004"
    },
    {
      kod: "SYLO",
      nazwa: "Logostour",
      naszid: "TOOP00187"
    },
    {
      kod: "VMAT",
      nazwa: "Matimpex Travel",
      naszid: "TOOP00002"
    },
    {
      kod: "NKRA",
      nazwa: "Nekera",
      naszid: "TOOP00188"
    },
    {
      kod: "VITX",
      nazwa: "Nowa Itaka (VITX)",
      naszid: "TOOP00063"
    },
    {
      kod: "VITD",
      nazwa: "Nowa Itaka (VITD)",
      naszid: "TOOP00063"
    },
    {
      kod: "VITN",
      nazwa: "Nowa Itaka (VITN)",
      naszid: "TOOP00063"
    },
    {
      kod: "OASI",
      nazwa: "Oasis",
      naszid: "TOOP00069"
    },
    {
      kod: "OKTU",
      nazwa: "OK Tours",
      naszid: "TOOP00172"
    },
    {
      kod: "ONHO",
      nazwa: "Onholidays Polska",
      naszid: "TOOP00190"
    },
    {
      kod: "OSKR",
      nazwa: "Oskar",
      naszid: "TOOP00141"
    },
    {
      kod: "VOTI",
      nazwa: "Otium",
      naszid: "TOOP00068"
    },
    {
      kod: "PWAK",
      nazwa: "Plus Wakacje",
      naszid: "TOOP00191"
    },
    {
      kod: "PRTS",
      nazwa: "Prestige Tours",
      naszid: "TOOP00192"
    },
    {
      kod: "BVPR",
      nazwa: "Prima Holiday",
      naszid: "TOOP00168"
    },
    {
      kod: "RNBW",
      nazwa: "Rainbow Tours",
      naszid: "TOOP00114"
    },
    {
      kod: "SYRG",
      nazwa: "Regent",
      naszid: "TOOP00157"
    },
    {
      kod: "REGO",
      nazwa: "RegoBis",
      naszid: "TOOP00193"
    },
    {
      kod: "SNOW",
      nazwa: "Snowtrex",
      naszid: "TOOP00131"
    },
    {
      kod: "SFPL",
      nazwa: "Sun&Fun",
      naszid: "TOOP00135"
    },
    {
      kod: "CKVI",
      nazwa: "Travel Family",
      naszid: "TOOP00194"
    },
    {
      kod: "XYOB",
      nazwa: "Yobboo - Zing Travel",
      naszid: "TOOP00171"
    }
  ]
};
